import { VIEW_MODES, type ViewMode } from './TextEditor.ts';

/**
 * Canvas zoom is persisted per surface — the author canvas and the viewer widget each own a key —
 * so anything positioning against a zoomed canvas must read the key for its own view mode.
 *
 * Keys are fully qualified: pass `{ prefix: '' }` when reading or writing through `useStorage`.
 */
export const ZOOM_STORAGE_KEYS = {
  [VIEW_MODES.AUTHOR]: 'aglmd-web-flowchart-zoom-author',
  // Outside the author, the viewer widget owns the only zoomable canvas, so the read-only modes
  // share its key.
  [VIEW_MODES.EHR]: 'aglmd-web-widgets-zoom',
  [VIEW_MODES.REVIEWER]: 'aglmd-web-widgets-zoom',
  [VIEW_MODES.STATIC]: 'aglmd-web-widgets-zoom',
  [VIEW_MODES.VIEWER]: 'aglmd-web-widgets-zoom'
} as const satisfies Record<ViewMode, string>;
